export default {
  namespaced: true,
  state: {
    store_name: null,
    store_detail_id: null
  },
  mutations: {
    setStoreName(state, name) {
      state.store_name = name;
    },
    setStoreDetailId(state, id) {
      state.store_detail_id = id;
    },
    setStoreNameAndDetailId(state, { name, id }) {
      state.store_name = name;
      state.store_detail_id = id;
    }
  },
  actions: {
    getProvince({ commit }, province_id) { }
  },
  getters: {}
};
